
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { DnsRecordType } from 'enums/DnsRecordType';
import { Model, ModelProperty } from 'models/Model';


export class DnsRecordModel extends Model<DnsRecordModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string' },
		{ name: 'type', type: 'DnsRecordType' },
		{ name: 'data', type: 'string' },
		{ name: 'ttl', type: 'number' },
		{ name: 'priority', type: 'number' }
	];
	[key: string]: any;
	
	public name: string;
	public type?: DnsRecordType;
	public data: string;
	public ttl?: number;
	public priority?: number;
    
	constructor(){
		super();
		this.name = '';
		this.type = undefined;
		this.data = '';
		this.ttl = undefined;
		this.priority = undefined;
		
	}
	getProperties(){
		return DnsRecordModel.classProperties;
	}
}

